import React, { FC } from "react";
import { ErrMsg } from "./ErrorMessage.style";

export interface IErrorMessage {
  caption?: string;
  showError?: boolean;
}

const ErrorMessage: FC<IErrorMessage> = ({ showError, caption }) => {
  if (showError) {
    return <ErrMsg>{caption}</ErrMsg>;
  } else {
    return null;
  }
};

export default ErrorMessage;
